import { useState } from 'react';
import useCouponRedirect from './useCouponRedirect';
import { useAlert } from '../context/AlertContext';
import useUTMParams from './useUTMParams';
import { getClickIdFromLink, pushEvent } from '../utils/dataLayer';

export default function useCopyCoupon({ cupomLink, couponId, storeSlug, incentiveId, userId }) {
    const { showAlert } = useAlert();
    const { getcouponRedirect } = useCouponRedirect();
    const { utmSource, utmCampaign } = useUTMParams();
    const [loading, setLoading] = useState(false);

    const copyAndRedirect = async (couponCode, handleClose) => {
        try {
        setLoading(true);
        await navigator.clipboard.writeText(couponCode);

        const trackedLink = await getcouponRedirect({
            link: cupomLink,
            source: utmSource,
            campaign: utmCampaign,
            userId: userId ? userId.toString() : undefined,
            coupon: couponId,
            store: storeSlug,
            incentive: +incentiveId,
        });

        if (!trackedLink) throw new Error("Link de redirecionamento não retornado.");

        const clickId = getClickIdFromLink(trackedLink);
        if (clickId) pushEvent('click-tracked', { clickId });

        const openLink = () => window.open(trackedLink, "_blank", "noopener,noreferrer");
        const isMobile = /Android|webOS|iPhone|iPad|iPod/i.test(navigator.userAgent);

        isMobile ? window.location.assign(trackedLink) : openLink();
        handleClose();

        } catch (err) {
        showAlert(`Erro ao redirecionar: ${err.message}`, "error");
        } finally {
        setLoading(false);
        }
    };

    return { copyAndRedirect, loading };
}